module.exports = __webpack_public_path__ + "img/rmb_logo.82a88b4c.svg";